import React from 'react';
import { useSelector } from 'react-redux';

export type GeneralInfoPair = {
  label: string;
  value: string;
};

interface IGeneralInfoModal {
  data: GeneralInfoPair[];
}

const GeneralInfoModal = ({ data }: IGeneralInfoModal): JSX.Element => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  return (
    <div className="offers-secondary-general-info-container">
      <h6>{nls.modalOffersSecondary.generalInfo.showResults}</h6>
      <div className="offers-secondary-general-info-data-container">
        {data.map((generalInfoPair, index) => (
          <>
            <p
              className="offers-secondary-general-info-data-label"
              key={generalInfoPair?.label + index}
            >
              {generalInfoPair?.label}
            </p>
            <p
              className="offers-secondary-general-info-data-value"
              key={generalInfoPair?.value + index}
            >
              {generalInfoPair?.value}
            </p>
          </>
        ))}
      </div>
    </div>
  );
};

export default GeneralInfoModal;
